module.exports = __webpack_public_path__ + "img/pic2.9f271b2a.png";